import CircularProgress, { CircularProgressProps } from '@mui/material/CircularProgress';


export const ProgressIcon: React.VFC<{
  size?: number; sx?: CircularProgressProps['sx']; }> = ({ size = 14, sx }) => (
  <CircularProgress color="inherit" size={size} thickness={6} sx={sx} />
);
